export default {
      id: "oc-dashboard-alert-sum-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-dashboard-alert-sum",
      toString: function () {
        return this.url;
      }
    }